<template>
    <div class="component-wrap" data-app="true">
        <Header-menu />
        <div class="wrapper">
            <User-menu />
            <v-layout column :class="{'pa-4': $vuetify.breakpoint.smAndUp}">
                <v-breadcrumbs class="pl-0" :class="{'mx-3': $vuetify.breakpoint.xs}">
                    <v-icon slot="divider">keyboard_arrow_left</v-icon>
                    <router-link to="/">
                        <v-breadcrumbs-item>
                            <v-icon class="mr-1">keyboard_arrow_left</v-icon> {{ $t("Главная") }}
                        </v-breadcrumbs-item>
                    </router-link>
                    <router-link to="/employee_study">
                        <v-breadcrumbs-item>
                            <v-icon class="mr-1">keyboard_arrow_left</v-icon> {{ $t("Статистика") }}
                        </v-breadcrumbs-item>
                    </router-link>
                    <!-- <div>
                        <v-breadcrumbs-item :disabled="true">
                            <v-icon class="mr-1">keyboard_arrow_left</v-icon> {{ saved_department.text || '' }}
                        </v-breadcrumbs-item>
                    </div> -->
                </v-breadcrumbs>
                <div>
                    <v-layout row wrap align-center
                              justify-space-between :class="{'mx-3': $vuetify.breakpoint.xs}"
                    >
                        <v-flex xs12>
                            <h1 class="section-title-main my-3 font-weight-regular">{{ saved_department.text || '' }}</h1>
                        </v-flex>
                    </v-layout>
                    <coursesStat :courses_stats="total_stats" />
                    <v-layout row wrap align-end
                              justify-space-between :class="{'mx-3 my-3': $vuetify.breakpoint.xs, 'my-5': $vuetify.breakpoint.smAndUp}"
                    >
                        <v-flex md5 sm7 xs12
                                :class="{'mb-4': $vuetify.breakpoint.smAndDown,'mr-4 mb-0': $vuetify.breakpoint.smAndUp}"
                        >
                            <inputIcon v-model="search_table" class="layout row search--no-border" icon_name="search"
                                       :placeholder="$t('Поиск по разделу')"
                            />
                        </v-flex>
                        <router-link :to="String(export_url.url)" target="_blank"><buttonRed class="flex md3 sm5 xs12" :class="{'my-3': $vuetify.breakpoint.xs}">{{ $t("Экспорт данных") }}</buttonRed></router-link>
                        <buttonBdWhite class="flex md3 sm5 xs12" @click.native="toggle_filter()">{{ showed_filter ? $t('Скрыть фильтр') : $t('Показать фильтр') }}</buttonBdWhite>
                    </v-layout>
                    <v-layout v-if="showed_filter" class="wrap align-end justify-space-between" :class="{'mx-3 mb-3': $vuetify.breakpoint.xs, 'mb-5': $vuetify.breakpoint.smAndUp}">
                        <v-flex v-if="permission.users" md4 sm5
                                xs6
                                xs12 class="mb-4 align-self-center"
                        >
                            <div class="text-uppercase pb-3">{{ $t("Пользователи") }}</div>
                            <v-layout>
                                <checkbox id="internal" :checked="filter_values.internal" class="mr-4"
                                          @change="get_user_type($event)"
                                >{{ $t("Внутренние") }}</checkbox>
                                <checkbox id="external" :checked="filter_values.external" @change="get_user_type($event)">{{ $t("Внешние") }}</checkbox>
                            </v-layout>
                        </v-flex>
                        <v-flex v-if="permission.groups" md4 sm5
                                xs6
                                xs12 class="mb-4 align-self-center"
                        >
                            <div class="text-uppercase pb-3">{{ $t("Группы организаций") }}</div>
                            <v-layout>
                                <checkbox id="clients" class="mr-4" :checked="filter_values.clients"
                                          @change="get_company_group($event)"
                                >{{ $t("Клиенты") }}</checkbox>
                                <checkbox id="lukoil" :checked="filter_values.lukoil" @change="get_company_group($event)">{{ $t("Лукойл") }}</checkbox>
                            </v-layout>
                        </v-flex>
                        <v-flex v-if="permission.groups" md4 sm5
                                xs12
                                class="mb-4"
                        >
                            <v-select
                                :items="total_stats.filter_company"
                                solo
                                append-icon=""
                                :label="$t('Все типы организаций')"
                                class="input"
                                :value="filter_values.company"
                                @change="get_company($event)"
                            >
                              <template #append>
                                <v-icon aria-hidden="true" translate="no">
                                  expand_more
                                </v-icon>
                              </template>
                            </v-select>
                        </v-flex>
                        <v-flex v-if="permission.location" md5 sm5
                                xs12
                                class="mb-4"
                        >
                            <v-layout column>
                                <div class="text-uppercase mb-3">{{ $t("Локация") }}</div>
                                <v-autocomplete
                                    :items="total_stats.filter_regions"
                                    solo
                                    append-icon=""
                                    :label="$t('Все регионы')"
                                    class="input"
                                    :value="filter_values.region"
                                    @change="get_region($event)"
                                >
                                  <template #append>
                                    <v-icon aria-hidden="true" translate="no">
                                      expand_more
                                    </v-icon>
                                  </template>
                                </v-autocomplete>
                            </v-layout>
                        </v-flex>
                        <v-flex v-if="permission.location" md5 sm5
                                xs12
                                class="mb-4"
                        >
                            <v-layout column>
                                <v-select
                                    :items="total_stats.filter_cities"
                                    solo
                                    append-icon=""
                                    :label="$t('Все города')"
                                    class="input"
                                    :value="filter_values.city"
                                    @change="get_city($event)"
                                >
                                  <template #append>
                                    <v-icon aria-hidden="true" translate="no">
                                      expand_more
                                    </v-icon>
                                  </template>
                                </v-select>
                            </v-layout>
                        </v-flex>
                        <v-flex lg4 md3 sm5
                                xs12 class="mb-4"
                        >
                            <v-layout column>
                                <div class="text-uppercase mb-3">{{ $t("Курсы") }}</div>
                                <v-select
                                    :items="total_stats.filter_courses"
                                    solo
                                    append-icon=""
                                    :label="$t('Все курсы')"
                                    class="input"
                                    :value="filter_values.course"
                                    @change="get_course($event)"
                                >
                                  <template #append>
                                    <v-icon aria-hidden="true" translate="no">
                                      expand_more
                                    </v-icon>
                                  </template>
                                </v-select>
                            </v-layout>
                        </v-flex>
                        <v-flex lg3 md3 sm5
                                xs12 class="align-self-center" :class="{'mb-4': $vuetify.breakpoint.xs, 'pl-4': $vuetify.breakpoint.mdAndUp}"
                        >
                            <checkbox id="required_courses" :checked="filter_values.course_required" @change="get_course_required($event)">{{ $t("Обязательные курсы") }}</checkbox>
                        </v-flex>
                        <v-flex lg5 md6 sm12
                                xs12 class="mb-4"
                        >
                            <div class="text-uppercase mb-3">{{ $t("Дата/Период") }}</div>
                            <v-layout row wrap justify-space-between>
                                <datepicker ref="datafilter_from" :class="{'mb-3': $vuetify.breakpoint.xs, 'mr-3': $vuetify.breakpoint.sm }" class="flex md6 sm5 xs12"
                                            placeholder="01-01-2018"
                                            :value="filter_values.period_start" @change="get_period_start($event)"
                                />
                                <datepicker ref="datafilter_to" class="flex xs12 sm5 md6" placeholder="01-01-2018"
                                            :value="filter_values.period_finish"
                                            @change="get_period_finish($event)"
                                />
                            </v-layout>
                        </v-flex>
                        <v-flex v-if="permission.employees" md3 sm5
                                xs12
                                class="mb-4"
                        >
                            <v-layout column>
                                <div class="text-uppercase mb-3">{{ $t("Сотрудники") }}</div>
                                <v-select
                                    :items="total_stats.filter_user_roles"
                                    solo
                                    append-icon=""
                                    :label="$t('Все роли')"
                                    class="input"
                                    :value="filter_values.role"
                                    @change="get_role($event)"
                                >
                                  <template #append>
                                    <v-icon aria-hidden="true" translate="no">
                                      expand_more
                                    </v-icon>
                                  </template>
                                </v-select>
                            </v-layout>
                        </v-flex>
                        <v-flex v-if="permission.employees" md3 sm5
                                xs12
                                class="mb-4"
                        >
                            <v-select
                                :items="total_stats.filter_user_specialization"
                                solo
                                append-icon=""
                                :label="$t('Все специализации')"
                                class="input"
                                :value="filter_values.specialization"
                                @change="get_specialization($event)"
                            >
                              <template #append>
                                <v-icon aria-hidden="true" translate="no">
                                  expand_more
                                </v-icon>
                              </template>
                            </v-select>
                        </v-flex>
                        <v-flex lg4 md5 sm8
                                xs12 class="mb-4"
                        >
                            <v-layout wrap align-center justify-end>
                                <redLink class="pr-3" :class="{'flex xs12 mb-4': $vuetify.breakpoint.xs}" @click.prevent="reset_filter">{{ $t("Сбросить фильтр") }}</redLink>
                                <buttonRed :class="{'flex xs12': $vuetify.breakpoint.xs}" @click.native="accept_filter()">{{ $t("Применить") }}</buttonRed>
                            </v-layout>
                        </v-flex>
                    </v-layout>
                    <v-tabs
                        v-model="active_tab"
                        slot="extension"
                        color="white"
                        :slider-color="tabsColor"
                    >
                        <v-tab class="wrapper-relative" href="#organizations" width="260px">
                            <v-layout row wrap align-center>
                                <v-flex md2>
                                    <svg v-svg
                                         symbol="organizations"
                                         size="32 32"
                                         class="icon"
                                         role="presentation"
                                    />
                                </v-flex>
                                <v-flex sm12 xs12 md9
                                        :class="{'pl-0 caption': $vuetify.breakpoint.smAndDown,'pl-3': $vuetify.breakpoint.mdAndUp}"
                                >{{ $t("Организации") }}</v-flex>
                                <v-flex class="md1 study__badge">
                                    <v-badge color="#84a45d">
                                        <span slot="badge">{{ employee_study_org.content.body.length }}</span>
                                    </v-badge>
                                </v-flex>
                            </v-layout>
                        </v-tab>
                        <v-tab class="wrapper-relative" href="#users">
                            <v-layout row wrap align-center>
                                <v-flex md2>
                                    <svg v-svg
                                         symbol="rating_internal"
                                         size="32 32"
                                         class="icon"
                                         role="presentation"
                                    />
                                </v-flex>
                                <v-flex sm12 xs12 md9
                                        :class="{'pl-0 caption': $vuetify.breakpoint.smAndDown,'pl-3': $vuetify.breakpoint.mdAndUp}"
                                >{{ $t("Пользователи") }}</v-flex>
                                <v-flex class="md1 study__badge">
                                    <v-badge color="#2755cf">
                                        <span slot="badge">{{ employee_study_users_filtered.content.body.length }}</span>
                                    </v-badge>
                                </v-flex>
                            </v-layout>
                        </v-tab>
                        <v-tab class="wrapper-relative" href="#courses">
                            <v-layout row wrap align-center>
                                <v-flex md2>
                                    <svg v-svg
                                         symbol="courses"
                                         size="32 32"
                                         class="icon"
                                         role="presentation"
                                    />
                                </v-flex>
                                <v-flex sm12 xs12 md9
                                        :class="{'pl-0 caption': $vuetify.breakpoint.smAndDown,'pl-3': $vuetify.breakpoint.mdAndUp}"
                                >{{ $t("Обучающие курсы") }}</v-flex>
                                <v-flex class="md1 study__badge">
                                    <v-badge color="#44b69e">
                                        <span slot="badge">{{ employee_study_courses.content.body.length }}</span>
                                    </v-badge>
                                </v-flex>
                            </v-layout>
                        </v-tab>
                        <v-tabs-items class="" :class="{'my-3': $vuetify.breakpoint.xs, 'my-5': $vuetify.breakpoint.smAndUp}" touchless>
                            <v-layout align-start wrap>
                                <v-flex xs12 :class="{'order-md1': $vuetify.breakpoint.mdAndUp}">
                                    <v-tab-item
                                        id="organizations"
                                    >
                                        <dataTable :table="employee_study_org" type="organizations" />
                                        <dataTablePagination :table="employee_study_org" />
                                    </v-tab-item>
                                    <v-tab-item
                                        id="users"
                                    >
                                        <dataTable :table="employee_study_users_filtered" type="users" />
                                        <dataTablePagination :table="employee_study_users_filtered" />
                                    </v-tab-item>
                                    <v-tab-item
                                        id="courses"
                                    >
                                        <dataTable :table="employee_study_courses" type="courses" />
                                        <dataTablePagination :table="employee_study_courses" />
                                    </v-tab-item>
                                </v-flex>
                            </v-layout>
                        </v-tabs-items>
                    </v-tabs>
                    <v-dialog :value="employee_study_modal.active" persistent content-class="scrolled-dialog">
                        <employeeStudyModal v-if="employee_study_modal.active" />
                    </v-dialog>
                    <v-dialog :value="course_stat_modal.active" persistent content-class="scrolled-dialog">
                        <courseStatModal v-if="course_stat_modal.active" />
                    </v-dialog>
                </div>
            </v-layout>
        </div>
        <FooterBlock />
    </div>
</template>

<script>
import HeaderMenu    from '@/components/blocks/common/Header_menu.vue';
import UserMenu      from '@/components/blocks/common/User_menu.vue';
import FooterBlock   from '@/components/blocks/common/Footer.vue';
import inputIcon   from '@/components/ui/inputs/typed/input_icon';
import buttonRed   from '@/components/ui/buttons/button_red';
import buttonBdWhite from '@/components/ui/buttons/button_bd_white';
import checkbox from '@/components/ui/inputs/base/checkbox.vue';
import datepicker from '@/components/ui/inputs/base/datepicker.vue';
import redLink from '@/components/ui/links/styled/link_red';
import employeeStudyModal from '../Employee_study_modals/Employee_study_modal';
import courseStatModal from '../Employee_study_modals/Course_stat_modal';
import dataTable from '../Employee_study_table';
import dataTablePagination from '../Employee_study_pagination';
import coursesStat from './../Employee_study_stats';
import {mapGetters, mapMutations, mapActions} from 'vuex';

export default {
  components: {
    HeaderMenu,
    UserMenu,
    FooterBlock,
    inputIcon,
    buttonRed,
    buttonBdWhite,
    checkbox,
    datepicker,
    redLink,
    employeeStudyModal,
    courseStatModal,
    dataTable,
    dataTablePagination,
    coursesStat,
  },
  data() {
    return {
      value : [],
      search: '',
      user  : {
        role : 'manager',
        roles: ['admin', 'manager'],
      },
      filter_values: {
        internal       : false,
        external       : false,
        lukoil         : false,
        clients        : false,
        company        : 0,
        region         : 0,
        city           : 0,
        course         : 0,
        course_required: false,
        role           : 0,
        specialization : 0,
        period_start   : '',
        period_finish  : '',
      },
      request: {
        user_type      : [],
        company_group  : [],
        company        : 0,
        region         : 0,
        city           : 0,
        department     : 0,
        course         : 0,
        course_required: false,
        role           : 0,
        specialization : 0,
        period_start   : '',
        period_finish  : '',
        search         : '',
      },
      saved_department: {},
    };
  },
  computed: {
    permission() {
      return this.get_all_permissions();
    },
    showed_filter() {
      if (this.tab=='organizations') {
        return this.showed_org_filter;
      } else if (this.tab=='users') {
        return this.showed_users_filter;
      } else if (this.tab=='courses') {
        return this.showed_courses_filter;
      }
    },
    search_table: {
      get() {
        if (this.tab=='organizations') {
          return this.employee_study_org.content.search;
        } else if (this.tab=='users') {
          return this.employee_study_users.content.search;
        } else if (this.tab=='courses') {
          return this.employee_study_courses.content.search;
        }
      },
      set($event) {
        this.request.search = $event.target.value;
        if (this.tab=='organizations') {
          this.SEARCH_ORG($event.target.value);
        } else if (this.tab=='users') {
          this.SEARCH_USERS($event.target.value);
        } else if (this.tab=='courses') {
          this.SEARCH_COURSES($event.target.value);
        }
        return this.get_learning_stats({'filter': this.request, 'level': 'org'});
      },
    },
    ...mapGetters('employee_study/directorate', [
      'get_directorate_by_id',
      'example_directorate',
    ]),
    ...mapGetters('employee_study/organizations', [
      'employee_study_org',
      'showed_org_filter',
    ]),
    ...mapGetters('employee_study/users', [
      'employee_study_users',
      'employee_study_users_filtered',
      'showed_users_filter',
    ]),
    ...mapGetters('employee_study/courses', [
      'employee_study_courses',
      'showed_courses_filter',
    ]),
    ...mapGetters('employee_study', [
      'employee_study_modal',
      'get_all_permissions',
      'course_stat_modal',
      'tab',
      'total_stats',
      'export_url',
      'current_department',
    ]),
    tabsColor() {
      if (this.tab=='organizations') {
        return '#84a45d';
      } else if (this.tab=='users') {
        return '#2755cf';
      } else if (this.tab=='courses') {
        return '#44b69e';
      }
    },
    active_tab: {
      get() {
        return this.tab;
      },
      set($event) {
        this.SET_ACTIVE_TAB($event);
        return this.get_learning_stats({'filter': this.request, 'level': 'org'});
      },
    },
  },
  async mounted() {
    console.debug("mounted: employee_study_organizations");

    this.saved_department = localStorage.current_department ? JSON.parse(localStorage.getItem('current_department')) : {};
    this.request.department = this.saved_department.id;

    await this.get_total_stats();
    await this.get_learning_stats({'filter': this.request, 'level': 'org'});
    await this.get_learning_stats({'filter': {...this.request, tab: 'users'}, 'level': 'org'});
    await this.get_learning_stats({'filter': {...this.request, tab: 'courses'}, 'level': 'org'});
  },
  methods: {
    ...mapMutations('employee_study', [
      'SET_ACTIVE_TAB',
    ]),
    ...mapActions('employee_study', [
      'get_learning_stats',
      'get_total_stats',
    ]),
    ...mapMutations('employee_study/organizations', [
      'TOGGLE_ORG_FILTER',
      'SEARCH_ORG',
    ]),
    ...mapMutations('employee_study/users', [
      'TOGGLE_USERS_FILTER',
      'SEARCH_USERS',
    ]),
    ...mapMutations('employee_study/courses', [
      'TOGGLE_COURSES_FILTER',
      'SEARCH_COURSES',
    ]),
    ...mapActions('employee_study/organizations', [
      'get_organizations',
    ]),
    toggle_filter() {
      if (this.tab=='organizations') {
        this.TOGGLE_ORG_FILTER(event);
      } else if (this.tab=='users') {
        this.TOGGLE_USERS_FILTER(event);
      } else if (this.tab=='courses') {
        this.TOGGLE_COURSES_FILTER(event);
      }
    },
    percent(total, value) {
      if (value<total) {
        return Math.round((value/total)*100);
      } else return 100;
    },
    get_user_type(event) {
      if (event.target) {
        if (this.request.user_type.includes(event.target.id)) {
          let index = this.request.user_type.indexOf(event.target.id);
          this.request.user_type.splice(index, 1);
          this.filter_values[event.target.id] = false;
        } else {
          this.filter_values[event.target.id] = true;
          this.request.user_type.push(event.target.id);
        }
      }
    },
    get_company_group(event) {
      if (event.target) {
        if (this.request.company_group.includes(event.target.id)) {
          let index = this.request.company_group.indexOf(event.target.id);
          this.request.company_group.splice(index, 1);
          this.filter_values[event.target.id] = false;
        } else {
          this.filter_values[event.target.id] = true;
          this.request.company_group.push(event.target.id);
        }
      }
    },
    get_company(event) {
      let company = this.total_stats.filter_company.find((item)=>item.text==event);
      if (company) {
        this.request.company = company.id;
        this.filter_values.company = event;
      }
    },
    get_region(event) {
      let region = this.total_stats.filter_regions.find((item)=>item.text==event);
      if (region) {
        this.request.region = region.id;
        this.filter_values.region = event;
      }
    },
    get_city(event) {
      let city = this.total_stats.filter_cities.find((item)=>item.text==event);
      if (city) {
        this.request.city = city.id;
        this.filter_values.city = event;
      }
    },
    get_course(event) {
      let course = this.total_stats.filter_courses.find((item)=>item.text==event);
      if (course) {
        this.request.course = course.id;
        this.filter_values.course = event;
      }
    },
    get_course_required(event) {
      if (event.target && event.target.checked || event===true) {
        this.request.course_required = 'Y';
        this.filter_values.course_required = true;
      } else {
        this.request.course_required = '';
        this.filter_values.course_required = false;
      }
    },
    get_role(event) {
      let role = this.total_stats.filter_user_roles.find((item)=>item.text==event);
      if (role) {
        this.request.role = role.id;
        this.filter_values.role = event;
      }
    },
    get_specialization(event) {
      let specialization = this.total_stats.filter_user_specialization.find((item)=>item.text==event);
      if (specialization) {
        this.request.specialization = specialization.id;
        this.filter_values.specialization = event;
      }
    },
    get_period_start(event) {
      this.request.period_start = event.target.value.split(' ')[0];
      this.filter_values.period_start = event.target.value;
    },
    get_period_finish(event) {
      this.request.period_finish = event.target.value.split(' ')[0];
      this.filter_values.period_finish = event.target.value;
    },
    async accept_filter() {
      await this.get_learning_stats({'filter': Object.assign(this.request, {department: this.saved_department.id}), 'level': 'org'});
    },
    reset_object(object) {
      for (let [key, value] of Object.entries(object)) {
        switch (Object.prototype.toString.call(value)) {
          case '[object String]':
            object[key] = '';
            break;
          case '[object Number]':
            object[key] = 0;
            break;
          case '[object Boolean]':
            object[key] = false;
            break;
          case '[object Array]':
            object[key] = [];
            break;
          default:
            object[key] = undefined;
        }
      }
    },
    reset_filter() {
      this.reset_object(this.request);
      this.reset_object(this.filter_values);

      this.$refs.datafilter_from.clear_calendar();
      this.$refs.datafilter_to.clear_calendar();

      this.accept_filter();

      if (this.tab=='organizations') {
        this.SEARCH_ORG('');
      } else if (this.tab=='users') {
        this.SEARCH_USERS('');
      } else if (this.tab=='courses') {
        this.SEARCH_COURSES('');
      }
    },
  },
};
</script>
